import { colorSchemeLightCold, themeQuartz } from 'ag-grid-community';

export const alarmGridTheme = themeQuartz.withPart(colorSchemeLightCold).withParams({
  fontFamily: 'Inter, system-ui, sans-serif',
  fontSize: 11.5,
  rowHeight: 32,
  headerHeight: 32,
  borderRadius: 6,
  headerBackgroundColor: '#f8fafc',
  borderColor: '#e2e8f0',
  oddRowBackgroundColor: '#f8fafc',
});
